import { isFalsy } from "@/lib/helpers";

export interface DefaultFilter {
  name: string;
  default_value?: any;
}

export const getDefaultsToSet = (
  filters: DefaultFilter[] = [],
  params: Record<string, any> = {}
) => {
  const hasExistingFilterParam = filters.some(
    (f) => !isFalsy(params[f.name])
  );

  if (hasExistingFilterParam) return {};

  return filters.reduce((acc, filter) => {
    if (!isFalsy(filter.default_value) && isFalsy(params[filter.name])) {
      acc[filter.name] = filter.default_value ?? null;
    }
    return acc;
  }, {} as Record<string, any>);
};
